 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-pages-404-mdx","6":"component---src-pages-about-mdx","7":"component---src-pages-accessibility-mdx","8":"component---src-pages-data-by-state-offshore-region-mdx","9":"component---src-pages-downloads-disbursements-by-month-mdx","10":"component---src-pages-downloads-disbursements-mdx","11":"component---src-pages-downloads-federal-revenue-by-company-mdx","12":"component---src-pages-downloads-federal-sales-mdx","13":"component---src-pages-downloads-index-mdx","14":"component---src-pages-downloads-production-by-disposition-mdx","15":"component---src-pages-downloads-production-by-month-mdx","16":"component---src-pages-downloads-production-mdx","17":"component---src-pages-downloads-revenue-mdx","18":"component---src-pages-explore-index-mdx","19":"component---src-pages-explore-offshore-regions-alaska-mdx","20":"component---src-pages-explore-offshore-regions-atlantic-mdx","21":"component---src-pages-explore-offshore-regions-gulf-mdx","22":"component---src-pages-explore-offshore-regions-pacific-mdx","23":"component---src-pages-explore-states-ak-mdx","24":"component---src-pages-explore-states-al-mdx","25":"component---src-pages-explore-states-ar-mdx","26":"component---src-pages-explore-states-az-mdx","27":"component---src-pages-explore-states-ca-mdx","28":"component---src-pages-explore-states-co-mdx","29":"component---src-pages-explore-states-fl-mdx","30":"component---src-pages-explore-states-id-mdx","31":"component---src-pages-explore-states-il-mdx","32":"component---src-pages-explore-states-in-mdx","33":"component---src-pages-explore-states-ks-mdx","34":"component---src-pages-explore-states-ky-mdx","35":"component---src-pages-explore-states-la-mdx","36":"component---src-pages-explore-states-md-mdx","37":"component---src-pages-explore-states-mi-mdx","38":"component---src-pages-explore-states-mn-mdx","39":"component---src-pages-explore-states-mo-mdx","40":"component---src-pages-explore-states-ms-mdx","41":"component---src-pages-explore-states-mt-mdx","42":"component---src-pages-explore-states-nc-mdx","43":"component---src-pages-explore-states-nd-mdx","44":"component---src-pages-explore-states-ne-mdx","45":"component---src-pages-explore-states-nm-mdx","46":"component---src-pages-explore-states-nv-mdx","47":"component---src-pages-explore-states-ny-mdx","48":"component---src-pages-explore-states-oh-mdx","49":"component---src-pages-explore-states-ok-mdx","50":"component---src-pages-explore-states-or-mdx","51":"component---src-pages-explore-states-pa-mdx","52":"component---src-pages-explore-states-sc-mdx","53":"component---src-pages-explore-states-sd-mdx","54":"component---src-pages-explore-states-tx-mdx","55":"component---src-pages-explore-states-ut-mdx","56":"component---src-pages-explore-states-va-mdx","57":"component---src-pages-explore-states-wa-mdx","58":"component---src-pages-explore-states-wi-mdx","59":"component---src-pages-explore-states-wv-mdx","60":"component---src-pages-explore-states-wy-mdx","61":"component---src-pages-fact-sheet-mdx","62":"component---src-pages-glossary-mdx","63":"component---src-pages-how-revenue-works-aml-reclamation-program-mdx","64":"component---src-pages-how-revenue-works-audits-and-assurances-mdx","65":"component---src-pages-how-revenue-works-coal-excise-tax-mdx","66":"component---src-pages-how-revenue-works-coal-mdx","67":"component---src-pages-how-revenue-works-disbursements-mdx","68":"component---src-pages-how-revenue-works-federal-laws-mdx","69":"component---src-pages-how-revenue-works-federal-reforms-mdx","70":"component---src-pages-how-revenue-works-gomesa-mdx","71":"component---src-pages-how-revenue-works-hpf-mdx","72":"component---src-pages-how-revenue-works-index-mdx","73":"component---src-pages-how-revenue-works-lwcf-mdx","74":"component---src-pages-how-revenue-works-minerals-mdx","75":"component---src-pages-how-revenue-works-native-american-ownership-governance-mdx","76":"component---src-pages-how-revenue-works-native-american-production-mdx","77":"component---src-pages-how-revenue-works-native-american-revenue-mdx","78":"component---src-pages-how-revenue-works-offshore-oil-gas-mdx","79":"component---src-pages-how-revenue-works-offshore-renewables-mdx","80":"component---src-pages-how-revenue-works-onshore-oil-gas-mdx","81":"component---src-pages-how-revenue-works-onshore-renewables-mdx","82":"component---src-pages-how-revenue-works-ownership-mdx","83":"component---src-pages-how-revenue-works-reclamation-mdx","84":"component---src-pages-how-revenue-works-revenues-mdx","85":"component---src-pages-index-mdx","86":"component---src-pages-information-quality-mdx","87":"component---src-pages-patterns-components-index-mdx","88":"component---src-pages-patterns-index-mdx","89":"component---src-pages-patterns-visual-styles-color-mdx","90":"component---src-pages-patterns-visual-styles-iconography-mdx","91":"component---src-pages-patterns-visual-styles-typography-mdx","92":"component---src-pages-plain-language-mdx","93":"component---src-pages-query-data-mdx","94":"component---src-pages-search-results-mdx","95":"component---src-pages-vdp-mdx"}[chunkId]||chunkId) + "-" + {"4":"6ee1700e433cfdf3ee02","5":"259c2c25cf7804563968","6":"54eeeb88adbf034c2959","7":"6ff11d3a157e93d3dfe7","8":"72fa53af48bcb61824b4","9":"6798b0a15d672691fdf3","10":"b3d301ff511a6e0c735e","11":"e35e34c2b705080bc905","12":"258e655ce6b889f902ed","13":"dc3325677a20ba1762d6","14":"a8b718089587598d7287","15":"03af568ec3603be2d1eb","16":"129c68669ca7b4bf0b5a","17":"89bed1e2a19afa5e79ba","18":"740f90609dbbb6d1942c","19":"5c9e51db264cedc76ec1","20":"f8431212749f509ae077","21":"0ff348c680a8f0d25af6","22":"48699840b32129355b5a","23":"2328fddfdcc54e36b7b3","24":"6efc2fa379b25afaff01","25":"89e28d660f9eacf86288","26":"e8d7c97738148f004987","27":"b8b077c2adbc145ffec8","28":"8e673fd97040038c96d5","29":"0fe4f7be8fa05d94447e","30":"83b5b4868aea9e21d195","31":"cbfd7c22febe51a7c4d6","32":"9b227bd3fef6b9b3340e","33":"5f8f7a2dd93d15cf2bbf","34":"d6be8486c5cbab84d605","35":"5c9d51732a9f043240bd","36":"65cfcd4119efdd0cc42f","37":"fd6307582882bddc081d","38":"1ff2e6438268818d60a3","39":"cf8a37bda3e5be33e2a4","40":"1dd7554af1330cf04cfe","41":"67935f6cdef829b70183","42":"fa8ec5ffa82228a7c641","43":"d2b54328a74d085002f2","44":"7ec7fda9abdf888eb69d","45":"8ee5c2e17091c76e7699","46":"de318af67971e9255904","47":"724491d79e98c5451a1d","48":"1db7bf4c4b24569b0c64","49":"90ed6146757a5a7826c6","50":"e794204e59e2e50d5021","51":"6280074cc502da6c63b9","52":"89a72795d09d521fcb8a","53":"2a25ed09c7561a0af1e4","54":"fff4e19c7deb61cd189b","55":"6680470ac8e86fcb9dc1","56":"3fc24320739fce5ed23b","57":"4136666df96492bcde22","58":"b8e7ec1fe0572ab5f4c4","59":"0546c74758ce69e6a9cc","60":"97ca6f58e0e6f8a66e3f","61":"7bb68c78db57a68687f1","62":"75fbe09d3909645eb68a","63":"d688715c9272dc49f57e","64":"c8e1559521a5e7348023","65":"4f53768753ba63d691dc","66":"9a4fa6bf299b8acfe9cb","67":"1473c3f467fc0879bb9c","68":"4942093ec2d961ba86f8","69":"6ac0d4316547eb497c6f","70":"be5a1dc30a8dacd94cda","71":"9c9e56777ad4d1bb8a9b","72":"5cd36f3da1d484a4f57a","73":"631137d0bb81bbfeeaa0","74":"e6cb572a92b644d09f25","75":"b0363b357d2497f096c2","76":"5b2fcef08dadcf4c5672","77":"a3cda3e625b54d976ec2","78":"2c1dd403203698288acd","79":"288422f3796dae8cff60","80":"dd753506b99c4b4674fc","81":"35c40b5ccf3415e6f0bd","82":"615c16e7e7c0c8b6c0da","83":"efb726525feb6683f69c","84":"10f5f293afc8539b983b","85":"cd9db5e6ea24ac205ed9","86":"e9aae22bb38ce433795d","87":"247cec01edba3fc48348","88":"b3341d2a09e739e918be","89":"6198e29132fe458c0cfd","90":"431dbaa21730fd050fc2","91":"c7138dbb8f254393dbe7","92":"ff3540b58442b81e5d19","93":"e5fa4d3a86acdc09be6d","94":"62f274e0e332fe159e72","95":"de52f77eb1117d0f59ef","100":"a6079d676e54aebaad42","101":"46b2982aa616cb84500a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sites/whats-new-v7.10.0/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
